import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useRadioButtonStyles } from './styles'

const RadioButton = ({ disabled, checked, value, label, onClick, ...props }) => {
  const classes = useRadioButtonStyles()

  return (
    <div
      className={classnames(classes.radioBtn, {
        [classes.radioBtnChecked]: checked,
        [classes.radioBtnDisabled]: disabled
      })}
      onClick={() => onClick(value)}
      {...props}
    >
      <span
        className={classnames(classes.circle, {
          checked
        })}
      />
      <label className={classes.label}>{label}</label>
    </div>
  )
}

RadioButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

RadioButton.defaultProps = {
  onClick: PropTypes.func
}

export default RadioButton
